import React, { memo, useMemo } from 'react';

import { Box, CircularProgress } from '@mui/material';
import { CancelIcon, MinusBoxIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { ExecutionStepStatus } from 'constants/aiChat';
import { StatusEnum } from 'constants/status';

import { DEFAULT_ICON_SIZE } from './StepProgressIndicator.constants';
import {
  activeExecutingSpinnerStyles,
  cancelledIconStyles,
  getPendingStyles,
  inactiveExecutingSpinnerStyles,
  skippedIconStyles,
} from './StepProgressIndicator.styles';

const StepProgressIndicator = ({ status, isActive = true, size = DEFAULT_ICON_SIZE }) => {
  const pendingStyles = useMemo(() => getPendingStyles(size), [size]);

  switch (status) {
    case ExecutionStepStatus.PENDING:
      return <Box sx={pendingStyles} />;

    case ExecutionStepStatus.EXECUTING:
      return (
        <CircularProgress
          size={size}
          sx={isActive ? activeExecutingSpinnerStyles : inactiveExecutingSpinnerStyles}
        />
      );

    case ExecutionStepStatus.COMPLETED:
      return <StatusIconCDS size={size} type={StatusEnum.SUCCESS} />;

    case ExecutionStepStatus.FAILED:
      return <StatusIconCDS size={size} type={StatusEnum.ERROR} />;

    case ExecutionStepStatus.CANCELLED:
      return <CancelIcon size={size} style={cancelledIconStyles} />;

    case ExecutionStepStatus.SKIPPED:
      return <MinusBoxIcon size={size} style={skippedIconStyles} />;

    default:
      return <Box sx={pendingStyles} />;
  }
};

StepProgressIndicator.propTypes = {
  status: PropTypes.oneOf(Object.values(ExecutionStepStatus)).isRequired,
  isActive: PropTypes.bool,
  size: PropTypes.number,
};

export default memo(StepProgressIndicator);
